module.exports = {"321102001":"正东路街道","321102002":"健康路街道","321102003":"大市口街道","321102004":"四牌楼街道","321102005":"象山街道","321102006":"谏壁街道","321102400":"京口工业园区","321102401":"新民洲临港产业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321102.json
// module id = 921
// module chunks = 0